import React from 'react';
import { AuthProvider } from './auth';
import { ConsultantProvider } from './consultant';
import { RefreshProvider } from './refresh';
import { ToastProvider } from './toast';
import { ScheduleTeamProvider } from './scheduleTeam';

interface AppProviderProps {
  children: React.ReactNode;
}

const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <AuthProvider>
      <ScheduleTeamProvider>
        <ConsultantProvider>
          <ToastProvider>
            <RefreshProvider>
              {children}
            </RefreshProvider>
          </ToastProvider>
        </ConsultantProvider>
      </ScheduleTeamProvider>
    </AuthProvider>
  );
};

export default AppProvider;